import React from 'react';

class AllergiesInformation extends React.Component {

    render() {
        const formInfo = this.props.formInfo;

        if (!formInfo) {
            return null;
        }

        return (
            <>
                <div className="card-body special-status-wrapper small-font">
                    <div>
                        <label style={{fontWeight: 500, display: 'inline', marginRight: '5px'}}>Pregnancy Status:</label>
                        <span>
                            {formInfo.currentlyPregnant || '-'}
                        </span>
                    </div>
                </div>
            </>
        );
    }

}

export default AllergiesInformation;
